import { FarmerPractice } from "../Models";
import { HUNDRED, ZERO, NO_VALUE_STRING, ONE, MIN_CELSIUS_VALUE, RATIO_TO_FERENHITE, FIVE } from "./Consts";
export const calculateSavedNutrients = (FarmerPractice: number | null, CropDemand: number | null): string => {
  if (CropDemand && FarmerPractice) {
    return CropDemand < FarmerPractice ? ((FarmerPractice / CropDemand) * HUNDRED - HUNDRED).toFixed(ONE).toString() + "%" : NO_VALUE_STRING;
  }
  return NO_VALUE_STRING;
};

export const celsiusToFahrenheit = (value: number) => Math.round((value * MIN_CELSIUS_VALUE) / FIVE + RATIO_TO_FERENHITE);

export const fahrenheitToCelsius = (value: number) => Math.round(((value - RATIO_TO_FERENHITE) * FIVE) / MIN_CELSIUS_VALUE);

export const yieldToImperial = (value: number) => value / 2.241693346;

export const yieldToMetric = (value: number) => value * 2.241693346;

export function getMaxFarmerPractice(fp: FarmerPractice): { key: "n" | "p" | "k"; value: number } | null {
  if (fp.n == null || fp.p == null || fp.k == null) return null;

  if (fp.n! > fp.p! && fp.n! > fp.k!) return { key: "n", value: fp.n! };
  if (fp.k! > fp.p! && fp.k! > fp.n!) return { key: "k", value: fp.k! };

  return { key: "p", value: fp.p! };
}
